import React from 'react';
import cx from 'classnames';

import { PrincipalFlag, PrincipalValue } from "api";
import { FormGroup, PrincipalSelect } from "ui/control";
import { useUndoableField } from "ui/control/field/undoable-field";
import FieldError from "ui/control/field/FieldError";
import { MaterialSymbol } from "ui/material-symbols";

interface Props {
    name: string;
    values?: PrincipalFlag[] | null;
    icons?: Partial<Record<PrincipalValue, MaterialSymbol>> | null;
    titles?: Partial<Record<PrincipalValue, string>> | null;
    caption?: string | null;
    long?: boolean | null;
    title?: string;
    disabled?: boolean;
    dropdownContainer?: Element | DocumentFragment | null;
    groupClassName?: string;
    labelClassName?: string;
    showError?: boolean;
    initialValue?: PrincipalValue | null;
    defaultValue?: PrincipalValue | null;
    setting?: string;
}

export function PrincipalField({
    name, values, icons, titles, caption, long, title, disabled, dropdownContainer, groupClassName, labelClassName,
    showError = false, initialValue, defaultValue, setting
}: Props) {
    const [{value}, {touched, error}, {setValue}, {undo, reset, onUndo, onReset}] =
        useUndoableField<PrincipalValue>(name, initialValue, defaultValue);

    return (
        <FormGroup
            title={title}
            name={name}
            labelClassName={labelClassName}
            groupClassName={groupClassName}
            horizontal
            layout="left"
            undo={undo}
            reset={reset}
            setting={setting}
            onUndo={onUndo}
            onReset={onReset}
        >
            <PrincipalSelect
                value={value}
                values={values}
                icons={icons}
                titles={titles}
                caption={caption}
                long={long}
                className={cx({"me-2": undo || reset})}
                disabled={disabled}
                dropdownContainer={dropdownContainer}
                onChange={v => setValue(v)}
            />
            {showError && touched && <FieldError error={error}/>}
        </FormGroup>
    );
}
